import { Heading } from "@otrium/atoms";
import { Trans } from "@lingui/macro";
import {
  CertificationRow,
  CertificationsWrapper,
  StyledCertificationText,
} from "src/molecules/GoodOnYou/GoodOnYou.styled";
import { FC, JSX } from "react";
import { useTheme, Theme } from "@emotion/react";
import { GoodOnYouCertification } from "src/molecules/GoodOnYou/types";
import styled from "@emotion/styled";

const Image = styled.img``;

interface Props {
  certifications: GoodOnYouCertification[];
  isRow?: boolean;
  smallHeadings?: boolean;
}

const certificationLogosMap: Record<number, JSX.Element> = {
  1: <Image src="/images/oeko-text.svg" />,
  2: <Image src="/images/global-organic-textile-standard.svg" />,
  3: <Image src="/images/blue-sign.svg" />,
  4: <Image src="/images/global-recycled-standard.svg" />,
  5: <Image src="/images/peta-approved.svg" />,
  6: <Image src="/images/wear-fair.svg" />,
  7: <Image src="/images/fairtrade.svg" />,
  8: <Image src="/images/certified-b-corporation.svg" />,
  9: <Image src="/images/peta-cruelty-free.svg" />,
};

const GoodOnYouCertifications: FC<Props> = ({
  certifications,
  isRow,
  smallHeadings,
}) => {
  const theme: Theme = useTheme();

  return (
    <>
      <Heading
        as="h5"
        variant={
          smallHeadings ? "body.source.semibold14" : "body.source.semibold16"
        }
        fontSize={
          smallHeadings
            ? theme.fontSizes.fontSize14
            : theme.fontSizes.fontSize16
        }
        pb={0}
        mb={2}
      >
        <Trans>Certifications</Trans>
      </Heading>
      {!smallHeadings && (
        <Trans>
          Independent certifications are one of many data sources Good On You®
          looks at when rating brands. Certifications may apply to a small
          selection of items only.
        </Trans>
      )}
      <CertificationsWrapper as="p">
        {certifications.map(({ id, name }) => (
          <CertificationRow key={id} isRow={isRow} as="span">
            {certificationLogosMap[id]}
            <StyledCertificationText as="span">{name}</StyledCertificationText>
          </CertificationRow>
        ))}
      </CertificationsWrapper>
    </>
  );
};

export default GoodOnYouCertifications;
